export default {"src":"/_next/static/media/1.a12e97f0.svg","height":38,"width":38,"blurWidth":0,"blurHeight":0};